import store from "../store"
import * as types from '@/store/mutation-types'
import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

// グローバルビフォーガードを実装する
export const globalBeforeGuard = (to,form,next) => {

  if(checkToAdminPage(to.name)) {
    // 遷移先が管理者のページの場合
    UtilityConsoleLog.consoleLog('beforeEach Admin')

    // ストア値が適正か確認する、
    // 適正ならばそのままページ遷移する
    // 適正でなければに管理者ログインページに遷移
    if(store.getters.isAdminUserLogin) {
      UtilityConsoleLog.consoleLog('beforeEach Admin OK')
      next()
    } else {
      UtilityConsoleLog.consoleLog('beforeEach Admin NG')
      next('/AdminLogin')
    }

    // 管理者用グローバルメニューの状態
    // 0:デフォルト表示（何も表示しない）以外ならば
    // 0:デフォルト表示を設定する
    if('0' != store.state.adminUserChoice.statusGlobalMenu) {
			// ストアに保存
			store.commit(
				types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
				{
					statusGlobalMenu: '0'
				}
			)
    }

  } else if(checkToLoginedCommonPage(to.name)) {
    // 遷移先がログインが必要な受診者のページの場合
    UtilityConsoleLog.consoleLog('beforeEach Common Logined')

    // ストア値が適正か確認する、
    // 適正ならばそのままページ遷移する
    // 適正でなければに共通エラーページに遷移
    if(store.getters.isCommonUserLogin) {
      UtilityConsoleLog.consoleLog('beforeEach Common Logined OK')
      next()
    } else {
      UtilityConsoleLog.consoleLog('beforeEach Common Logined NG')
      next('/UtilityError')
    }

	  // 一般用ナビゲーション表示の切り替え
	  // true: 表示ならばfalse: 非表示にする
    if(store.state.commonUserInfo.isDisplayNavigation) {
	  	// ストアに保存
	  	store.commit(
	  		types.COMMON_DISPLAYNAVIGATION,
	  		{
	  			isDisplayNavigation: false
	  		}
	  	)
    }

  } else if(checkToNoLoginedCommonPage(to.name)) {
    // 遷移先がログインが必要ない受診者のページの場合
    UtilityConsoleLog.consoleLog('beforeEach Common No Logined')

    // ストア値が適正か確認する、
    // 適正ならばそのままページ遷移する
    // 適正でなければに共通エラーページに遷移
    if(store.getters.isIrcd) {
      UtilityConsoleLog.consoleLog('beforeEach Common No Logined OK')
      next()
    } else {
      UtilityConsoleLog.consoleLog('beforeEach Common Logined NG')
      next('/UtilityError')
    }
  } else {
    UtilityConsoleLog.consoleLog('beforeEach Utility')
    next()
  }

  // 一般用ナビゲーション表示の切り替え
	// true: 表示ならばfalse: 非表示にする
  if(store.state.commonUserInfo.isDisplayNavigation) {
		// ストアに保存
		store.commit(
			types.COMMON_DISPLAYNAVIGATION,
			{
				isDisplayNavigation: false
			}
		)
  }
}

// 遷移先が管理者のページかどうか
// true:遷移先が管理者のページ
// false:遷移先が管理者のページではない
function checkToAdminPage(in_toName) {

  var result = false

  if(in_toName == 'AdminReserveStatusCheck'
    || in_toName == 'MasterWCALM'
    || in_toName == 'MasterWCALMBulk'
    || in_toName == 'CSVPatternList'
    || in_toName == 'CSVPatternDetail'
    || in_toName == 'WIGA1'
    || in_toName == 'WIGA1Detail'
    || in_toName == 'WIGA1Detail2'
    || in_toName == 'WIGA1DetailCalender'
    || in_toName == 'MasterWIRKNUpdate'
    || in_toName == 'MasterWIRKNUpdateDone'
    || in_toName == 'MasterWIRKSList'
    || in_toName == 'MasterWIRKSRegister'
    || in_toName == 'MasterWIRKSRegisterDone'
    || in_toName == 'MasterWIRKSDetail'
    || in_toName == 'MasterWIRKSDetailUpdate'
    || in_toName == 'MasterWIRKM'
    || in_toName == 'MasterWKSWK'
    || in_toName == 'MasterWRKKS'
    || in_toName == 'MasterWRKOP'
    || in_toName == 'MasterWJGYODetail'
    || in_toName == 'MasterWJGYODetailUpdate'
    || in_toName == 'MasterWJGYOList'
    || in_toName == 'MasterWJGYORegister'
    || in_toName == 'MasterWJGYORegisterDone'
    || in_toName == 'MasterWHFKBDetail'
    || in_toName == 'MasterWHFKBDetailUpdate'
    || in_toName == 'MasterWHFKBList'
    || in_toName == 'MasterWHFKBRegister'
    || in_toName == 'MasterWHFKBRegisterDone'
    || in_toName == 'MasterWKKMMDetail'
    || in_toName == 'MasterWKKMMDetailUpdate'
    || in_toName == 'MasterWKKMMList'
    || in_toName == 'MasterWKKMMRegister'
    || in_toName == 'MasterWKKMMRegisterDone'
    || in_toName == 'MasterWMAILDetail'
    || in_toName == 'MasterWMAILDetailUpdate'
    || in_toName == 'MasterWMAILList'
    || in_toName == 'MasterWMAILRegister'
    || in_toName == 'MasterWMAILRegisterDone'
    || in_toName == 'MasterWOPBRDetail'
    || in_toName == 'MasterWOPBRDetailUpdate'
    || in_toName == 'MasterWOPBRList'
    || in_toName == 'MasterWOPBRRegister'
    || in_toName == 'MasterWOPBRRegisterDone'
    || in_toName == 'MasterWOPKMDetail'
    || in_toName == 'MasterWOPKMDetailUpdate'
    || in_toName == 'MasterWOPKMList'
    || in_toName == 'MasterWOPKMRegister'
    || in_toName == 'MasterWOPKMRegisterDone'
    || in_toName == 'MasterWTMZNDetail'
    || in_toName == 'MasterWTMZNDetailUpdate'
    || in_toName == 'MasterWTMZNList'
    || in_toName == 'MasterWTMZNRegister'
    || in_toName == 'MasterWTMZNRegisterDone'
    || in_toName == 'MasterWWAKUDetail'
    || in_toName == 'MasterWWAKUDetailUpdate'
    || in_toName == 'MasterWWAKUList'
    || in_toName == 'MasterWWAKURegister'
    || in_toName == 'MasterWWAKURegisterDone'
    || in_toName == 'MasterWWKKR'
    || in_toName == 'MasterWWKKRBulk') {
      result = true
  }

  return result
}

// 遷移先がログインが必要な受診者のページかどうか
// true:遷移先がログインが必要な受診者のページ
// false:遷移先がログインが必要な受診者のページではない
function checkToLoginedCommonPage(in_toName) {

  var result = false

  if(in_toName == 'CommonMyPage'
    || in_toName == 'CommonChangePassword'
    || in_toName == 'CommonChangePassword2'
    || in_toName == 'CommonConfirmCancel'
    || in_toName == 'CommonConfirmCancel2'
    || in_toName == 'CommonReserveDetail'
    || in_toName == 'CommonReserveResult') {
      result = true
  }

  return result
}

// 遷移先がログインが必要ない受診者のページかどうか
// true:ログインが必要ない受診者のページ
// false:ログインが必要ない受診者のページではない
function checkToNoLoginedCommonPage(in_toName) {
  
  var result = false

  if(in_toName == 'CommonForgetPassword'
    || in_toName == 'CommonForgetPassword2'
    || in_toName == 'CommonNewHealthInsurance'
    || in_toName == 'CommonSelectCourse'
    || in_toName == 'CommonSelectOption'
    || in_toName == 'CommonSelectCalender'
    || in_toName == 'CommonInputReserveInfo'
    || in_toName == 'CommonConfirmReserveInfo') {
      result = true
  }

  return result
}





// WEBPACK FOOTER //
// ./src/router/globalGuards.js